import { DRAWING_MODE, MAP_LAYER } from 'components/Map/constants';
import { GEOJSON_BOUNDARY_TYPE } from 'components/Map/hooks/useFeatures/constants';

export {
    GEOJSON_FEATURE,
    GEOJSON_PROPERTY,
    GEOJSON_FEATURE_TYPE,
    GEOJSON_POLYGON_TYPE
} from 'components/Map/hooks/useFeatures/constants';

export { MAP_LAYER } from 'components/Map/constants';

export { MAP_EVENT_TYPE } from 'components/Map/hooks/useMapEvents/constants';

export const DRAWING_MODE_TO_GEOJSON_BOUNDARY_TYPE_MAP = {
    [DRAWING_MODE.APPLY]: GEOJSON_BOUNDARY_TYPE.APPLY,
    [DRAWING_MODE.NO_ENTRY]: GEOJSON_BOUNDARY_TYPE.NO_ENTRY
};

export const DRAWING_LAYERS_BY_MODE = {
    [DRAWING_MODE.APPLY]: {
        currentVertexLineStringLayer: MAP_LAYER.DRAWING_BOUNDARY_POLYGON_CURRENT_VERTEX_LINE,
        firstToLastLineStringLayer: MAP_LAYER.DRAWING_BOUNDARY_POLYGON_FIRST_TO_LAST_LINE,
        polygonFillLayer: MAP_LAYER.DRAWING_BOUNDARY_POLYGON_FILL,
        polygonOutlineLayer: MAP_LAYER.DRAWING_BOUNDARY_POLYGON_OUTLINE,
        vertexLayer: MAP_LAYER.DRAWING_POINT
    },
    [DRAWING_MODE.NO_ENTRY]: {
        currentVertexLineStringLayer: MAP_LAYER.DRAWING_OBSTACLE_POLYGON_CURRENT_VERTEX_LINE,
        firstToLastLineStringLayer: MAP_LAYER.DRAWING_OBSTACLE_POLYGON_FIRST_TO_LAST_LINE,
        polygonFillLayer: MAP_LAYER.DRAWING_OBSTACLE_POLYGON_FILL,
        polygonOutlineLayer: MAP_LAYER.DRAWING_OBSTACLE_POLYGON_OUTLINE,
        vertexLayer: MAP_LAYER.DRAWING_POINT
    }
};

export { MAP_ACTION_TYPE } from 'components/Map/hooks/useUndo/constants';
